<template>
    <!-- Шаблон для создания блока с фильтрами -->
    <div class="gz-filter-container">       
        <slot name="filters"></slot>
        <div class="gz-filters__data">
            <slot name="data"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseFiltersBar'
}
</script>